module.exports = __webpack_public_path__ + "media/images/sp/stores/hamamatsu/hamamatsu_concept_01-34be874b110006521157d89be850a32b.jpg";